import { render, staticRenderFns } from "./set_upper_lower.vue?vue&type=template&id=1cc9d981&scoped=true&"
import script from "./set_upper_lower.vue?vue&type=script&lang=js&"
export * from "./set_upper_lower.vue?vue&type=script&lang=js&"
import style0 from "./set_upper_lower.vue?vue&type=style&index=0&id=1cc9d981&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc9d981",
  null
  
)

export default component.exports